import { matchPath } from 'react-router'
export const contentPaths = '/(artikel|inspiration|om|tips-och-guider|tjanster|for-foretag|test)'
export const tips = '/(kop-tips|salj-tips)/:splat'

const paths = Object.freeze({
  AdWatchList: '/bevakningar/:adwatchId',
  CreateAdWatch: '/adwatch/create',
  Debug: '/adout/debug',
  ListRealEstate: '/annonser/:region?/bostad',
  List: '/annonser/:region?/:categoryGroup?/:mainCategory?/:subCategory?',
  DirectPurchase: '/annons/:region/:adTitle/:adId/kop-bilen-direkt',
  FinancePage: '/annons/:region/:adTitle/:adId/finans',
  CarAuction: '/fordon/tjanster/bilauktion',
  AdReplyView: '/annons/:region/:adTitle/:adId/svara-annons',
  Ad: '/annons/:region/:adTitle/:adId',
  SavedAds: '/sparade-annonser',
  Saved: '/sparade/:adwatchId?',
  SearchParams: '/filter/:parameter',
  Filter: '/filter',
  Store: '/butik/:storeName',
  Categories: '/kategorier',
  Stores: '/butiker',
  adNotFound: '/adout/notFound',
  errorPage: '/adout/500',
  Tips: tips,
  SellCarLandingPage: '/tjanster/salja-bil',
  AppraiseCarValue: '/tjanster/vardera-bil',
  ContentfulBasedPage: contentPaths,
  StartPage: '/',
})

export default paths

export function isAppRoute(test) {
  return Object.values(paths).some((path) => matchPath(test, { path, exact: path === '/' }))
}
